(function () {
  'use strict';
  if (window.KOLAKLanguageSubmit) return;
  window.KOLAKLanguageSubmit = true;
  var roots = {en:'',ja:'/ja',ko:'/ko',fr:'/fr',de:'/de',es:'/es',it:'/it','zh-CN':'/zh-hans',fil:'/fil','pt-BR':'/pt','zh-TW':'/zh-hant',ar:'/ar'};
  var supportedPrefixes = ['ja','ko','fr','de','es','it','zh-hans','fil','pt','zh-hant','ar'];
  function restore(form) {
    if (!form) return;
    delete form.dataset.kolakSubmitting;
    form.removeAttribute('aria-busy');
    var button = form.querySelector('#md-btn__form__onSubmit');
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('kolak-localization-pending');
    }
  }
  function commit(form, event) {
    if (!form || form.id !== 'md-modal__form__id') return;
    var language = form.querySelector('#md-form__select__language');
    var country = form.querySelector('#md-form__select__country');
    var locale = language && language.getAttribute('data-value');
    var countryCode = country && country.getAttribute('data-value');
    if (!Object.prototype.hasOwnProperty.call(roots, locale) || !/^[A-Z]{2}$/.test(countryCode || '')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.kolakSubmitting === 'true') return;
    if (!form.reportValidity()) return;
    function setInput(name, value) {
      var input = form.querySelector('input[name="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = value;
    }
    var segments = location.pathname.split('/').filter(Boolean);
    if (supportedPrefixes.indexOf(segments[0]) !== -1) segments.shift();
    var returnPath = roots[locale] + '/' + segments.join('/') + location.search;
    setInput('form_type', 'localization');
    setInput('utf8', '✓');
    setInput('_method', 'put');
    setInput('language_code', locale);
    setInput('country_code', countryCode);
    setInput('return_to', returnPath);
    form.dataset.kolakSubmitting = 'true';
    form.setAttribute('aria-busy', 'true');
    var button = form.querySelector('#md-btn__form__onSubmit');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('kolak-localization-pending');
    }
    try {
      HTMLFormElement.prototype.submit.call(form);
      setTimeout(function () { restore(form); }, 6000);
    } catch (error) {
      restore(form);
    }
  }
  window.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var button = event.target instanceof Element ? event.target.closest('#md-btn__form__onSubmit') : null;
    if (button) commit(button.form, event);
  }, true);
  window.addEventListener('submit', function (event) {
    commit(event.target, event);
  }, true);
  window.addEventListener('pageshow', function () {
    restore(document.getElementById('md-modal__form__id'));
  });
})();